import { useUnits } from './Units';

export default function SizeUnit({ inches, cm }) {
  const { units } = useUnits();

  return units === 'in' ? inches : cm;
}
